/* ==========================================================================
   md-size-guide.js - Tabela de Medidas da PDP (Match Day)

   O que ele faz (tudo em cima do markup do snippet md-size-guide.liquid):
   1. abre e fecha o <dialog> (o gatilho mora no rotulo da 1a opcao de variante
      e e recriado a cada troca de variante, por isso o clique e por delegacao);
   2. destaca a coluna/linha do tamanho selecionado e marca os esgotados;
   3. converte cm para in e kg para lb na TELA (o dado gravado nunca muda);
   4. mostra a nota de arrastar so quando a tabela visivel passa da largura;
   5. troca a ilustracao do bloco "how to measure" conforme a medida em foco.
   ========================================================================== */
(function () {
  'use strict';

  var CM_POR_POLEGADA = 2.54;
  var KG_POR_LIBRA = 0.45359237;
  // os EUA sao o mercado principal da loja (74% da receita), entao a tabela abre
  // em polegada e libra; quem quiser metrico troca no botao e a escolha vale pro
  // resto da navegacao
  var CHAVE_UNIDADE = 'md-sg-unidade';

  function unidadeSalva() {
    try {
      var valor = window.localStorage.getItem(CHAVE_UNIDADE);
      return valor === 'metrico' || valor === 'imperial' ? valor : null;
    } catch (erro) {
      return null;
    }
  }

  function guardarUnidade(valor) {
    try {
      window.localStorage.setItem(CHAVE_UNIDADE, valor);
    } catch (erro) {
      /* navegacao privada ou armazenamento bloqueado: a escolha vale so nesta pagina */
    }
  }

  var estadoUnidade = unidadeSalva() || 'imperial';

  // pointerdown existe? e ele que diz se o gesto de dispensa comecou no fundo
  var TEM_PONTEIRO = typeof window.PointerEvent === 'function';

  // o navegador conhece o seletor :modal? e ele que decide se o fallback inline
  // (dialog com atributo open, fora do top layer) ainda e uma saida aceitavel:
  // onde :modal existe, o CSS esconde esse estado de proposito
  var SUPORTA_MODAL = (function () {
    try {
      return !!(window.CSS && window.CSS.supports && window.CSS.supports('selector(dialog:modal)'));
    } catch (erro) {
      return false;
    }
  })();

  function porId(id) {
    return document.getElementById(id);
  }

  function dialogDoGatilho(gatilho) {
    var id = gatilho.id || '';
    if (id.indexOf('open-size-chart-') !== 0) return null;
    return porId('size-chart-modal-' + id.slice('open-size-chart-'.length));
  }

  /* ---------- leitura do seletor de variantes ---------- */
  function controlesDeTamanho(rotulos) {
    var inputs = Array.prototype.slice.call(
      document.querySelectorAll('variant-selects input[type="radio"][data-option-name], variant-selects option')
    );
    return inputs.filter(function (el) {
      return rotulos.indexOf((el.value || '').trim()) !== -1;
    });
  }

  function indisponivel(el) {
    if (el.disabled) return true;
    if (el.getAttribute('aria-disabled') === 'true') return true;
    var label = el.id ? document.querySelector('label[for="' + el.id + '"]') : null;
    return !!(label && label.className && label.className.indexOf('disabled') !== -1);
  }

  function selecionado(el) {
    return el.checked || el.selected;
  }

  /* ---------- sincronizacao de estado ---------- */
  function sincronizar(dialog) {
    var celulas = dialog.querySelectorAll('[data-md-sg-size]');
    var rotulos = [];
    celulas.forEach(function (c) {
      var nome = c.getAttribute('data-md-sg-size');
      if (rotulos.indexOf(nome) === -1) rotulos.push(nome);
    });

    var controles = controlesDeTamanho(rotulos);
    var atual = null;
    var estado = {};

    controles.forEach(function (el) {
      var nome = (el.value || '').trim();
      estado[nome] = indisponivel(el) ? 'esgotado' : 'ok';
      if (selecionado(el)) atual = nome;
    });

    var textos = {
      selecionado: dialog.getAttribute('data-md-sg-txt-selecionado') || 'Selected',
      esgotado: dialog.getAttribute('data-md-sg-txt-esgotado') || 'Sold out',
      ausente: dialog.getAttribute('data-md-sg-txt-ausente') || 'Not offered'
    };

    celulas.forEach(function (celula) {
      var nome = celula.getAttribute('data-md-sg-size');
      var ehAtual = nome === atual;
      celula.classList.toggle('md-sg-current', ehAtual);

      var linha = celula.closest('tr');
      if (linha && linha.closest('.md-sg-table--rows') && linha.querySelector('th[data-md-sg-size]') === celula) {
        linha.classList.toggle('md-sg-current', ehAtual);
      }

      var badge = celula.querySelector('[data-md-sg-badge]');
      if (!badge) return;

      var situacao = estado[nome];
      var texto = '';
      var fora = false;

      if (ehAtual) {
        texto = textos.selecionado;
      } else if (situacao === 'esgotado') {
        texto = textos.esgotado;
        fora = true;
      } else if (controles.length && situacao === undefined) {
        texto = textos.ausente;
        fora = true;
      }

      badge.textContent = texto;
      badge.hidden = !texto;
      badge.classList.toggle('md-sg-badge--out', fora);
    });

    // tamanhos que o produto tem mas a tabela nao mede
    var semMedida = [];
    var todosControles = Array.prototype.slice.call(
      document.querySelectorAll('variant-selects input[type="radio"][data-option-name], variant-selects option')
    );
    var nomeOpcao = null;
    controles.forEach(function (el) {
      if (!nomeOpcao) nomeOpcao = el.getAttribute('data-option-name');
    });
    if (nomeOpcao) {
      todosControles.forEach(function (el) {
        if (el.getAttribute('data-option-name') !== nomeOpcao) return;
        var nome = (el.value || '').trim();
        if (nome && rotulos.indexOf(nome) === -1 && semMedida.indexOf(nome) === -1) semMedida.push(nome);
      });
    }

    var aviso = dialog.querySelector('[data-md-sg-sem-medida]');
    if (aviso) {
      var molde = dialog.getAttribute('data-md-sg-txt-sem-medida') || '{sizes}: no measurements in this chart.';
      aviso.textContent = molde.replace('{sizes}', semMedida.join(', '));
      aviso.hidden = semMedida.length === 0;
    }
  }

  /* ---------- unidades ---------- */
  // O valor convertido sai INTEIRO: em polegada e libra a casa decimal nao
  // ajuda a escolher tamanho e so polui a tabela (pedido do Ivan, 22/09/2026).
  // O dado gravado no tema continua intacto - isto e so a exibicao.
  function formatar(numero) {
    return String(Math.round(numero));
  }

  function converterTexto(texto, base, imperial) {
    if (!imperial || !base) return texto;
    var divisor = base === 'kg' ? KG_POR_LIBRA : base === 'cm' ? CM_POR_POLEGADA : 0;
    if (!divisor) return texto;
    return texto.replace(/\d+(?:[.,]\d+)?/g, function (achado) {
      var numero = parseFloat(achado.replace(',', '.'));
      if (!isFinite(numero)) return achado;
      return formatar(numero / divisor);
    });
  }

  // intervalo com respiro: "110.2 - 136.7". So mexe em hifen ENTRE numeros, pra nao
  // tocar no traco solitario que alguns campos usam como "sem medida".
  // O espaco da esquerda e inquebravel (\u00a0): assim o traco anda sempre colado
  // no primeiro numero e nunca sobra sozinho numa linha, em tela estreita.
  function espacarHifen(texto) {
    return texto.replace(/(\d)\s*-\s*(\d)/g, '$1\u00a0- $2');
  }

  function rotuloUnidade(base, imperial) {
    if (!imperial) return base;
    if (base === 'cm') return 'in';
    if (base === 'kg') return 'lb';
    return base;
  }

  function aplicarUnidade(dialog) {
    var imperial = estadoUnidade === 'imperial';

    dialog.querySelectorAll('[data-md-sg-valor]').forEach(function (celula) {
      var base = celula.getAttribute('data-md-sg-unidade-base');
      if (!base) {
        var linha = celula.closest('tr');
        base = linha ? linha.getAttribute('data-md-sg-unidade-base') : '';
      }
      // colapsa so o hifen ENTRE numeros: em texto livre ("Free - size") o traco
      // e parte da frase e nao pode ser comido
      var original = (celula.getAttribute('data-md-sg-valor') || '').replace(/(\d)\s*-\s*(\d)/g, '$1-$2');
      celula.textContent = espacarHifen(converterTexto(original, base, imperial));
    });

    dialog.querySelectorAll('[data-md-sg-unidade-rotulo]').forEach(function (pequeno) {
      var dono = pequeno.closest('[data-md-sg-unidade-base]') || pequeno.closest('tr');
      var base = dono ? dono.getAttribute('data-md-sg-unidade-base') : '';
      if (!base) return;
      pequeno.textContent = rotuloUnidade(base, imperial);
    });

    dialog.querySelectorAll('[data-md-sg-unidade]').forEach(function (botao) {
      botao.setAttribute('aria-pressed', String(botao.getAttribute('data-md-sg-unidade') === estadoUnidade));
    });
  }

  /* ---------- ilustracao do bloco "how to measure" ---------- */
  function imagensPorMetrica(dialog) {
    var mapa = {};
    dialog.querySelectorAll('tr[data-md-sg-metrica][data-md-sg-img]').forEach(function (linha) {
      mapa[linha.getAttribute('data-md-sg-metrica')] = linha.getAttribute('data-md-sg-img');
    });
    return mapa;
  }

  function ligarIlustracao(dialog) {
    var ilustracao = dialog.querySelector('[data-md-sg-ilustracao]');
    if (!ilustracao) return;
    var padrao = ilustracao.getAttribute('data-md-sg-img-padrao');
    var mapa = imagensPorMetrica(dialog);

    dialog.addEventListener('mouseover', function (evento) {
      var alvo = evento.target.closest('[data-md-sg-metrica]');
      if (!alvo || !dialog.contains(alvo)) return;
      var url = mapa[alvo.getAttribute('data-md-sg-metrica')];
      if (url) ilustracao.src = url;
    });

    dialog.addEventListener('mouseleave', function () {
      if (padrao) ilustracao.src = padrao;
    });
  }

  /* ---------- abrir e fechar ---------- */

  // :modal responde se o dialog esta mesmo no top layer. Navegador que nao
  // conhece o seletor lanca, e ai tanto faz: ele tambem nao tem showModal.
  function ehModal(dialog) {
    try {
      return dialog.matches(':modal');
    } catch (erro) {
      return true;
    }
  }

  // Um <dialog> com o atributo open mas SEM showModal fica desenhado dentro da
  // pagina, como um bloco comum - foi assim que a tabela apareceu no meio da PDP
  // no print do Ivan (19/09/2026). Aqui o estado sempre termina em uma de duas
  // pontas: modal de verdade, ou fechado.
  function abrirComoModal(dialog) {
    if (typeof dialog.showModal !== 'function') {
      // navegador sem showModal: aqui o modal inline e o unico jeito, e o CSS
      // nao o esconde (a blindagem mora dentro de @supports selector(dialog:modal))
      dialog.setAttribute('open', '');
      return true;
    }
    if (dialog.open && ehModal(dialog)) return true;
    if (dialog.open) {
      // aberto fora do top layer (estado herdado): fecha pra poder subir certo
      try {
        dialog.close();
      } catch (erro) {
        dialog.removeAttribute('open');
      }
    }
    try {
      dialog.showModal();
      return true;
    } catch (erro) {
      try {
        dialog.close();
        dialog.showModal();
        return true;
      } catch (erro2) {
        if (SUPORTA_MODAL) {
          // ultimo recurso NAO pode ser o inline: o CSS esconderia o modal e a
          // pagina ficaria travada sem nada na tela. Melhor nao abrir.
          try {
            dialog.close();
          } catch (erro3) {
            dialog.removeAttribute('open');
          }
          return false;
        }
        dialog.setAttribute('open', '');
        return true;
      }
    }
  }

  /* ---------- vigia da trava de rolagem ----------
     Com o modal aberto a pagina fica com overflow:hidden. Se o <dialog> sair do
     DOM antes de fechar (o tema troca a coluna de informacoes inteira quando o
     cliente muda de variante), nenhum evento de fechamento dispara e a loja
     ficaria sem rolar ate o cliente recarregar. */
  var vigiaDaTrava = null;

  function pararVigia() {
    if (vigiaDaTrava) {
      window.clearInterval(vigiaDaTrava);
      vigiaDaTrava = null;
    }
  }

  function destravarPagina(dialog) {
    document.documentElement.style.overflow = dialog.dataset.mdSgOverflow || '';
  }

  function vigiarTrava(dialog) {
    pararVigia();
    vigiaDaTrava = window.setInterval(function () {
      var dePe = dialog.open && document.contains(dialog) && (!SUPORTA_MODAL || ehModal(dialog));
      if (dePe) return;
      destravarPagina(dialog);
      pararVigia();
    }, 300);
  }

  function ajustarNota(dialog) {
    var nota = dialog.querySelector('.md-sg-note');
    if (!nota) return;
    var visivel = null;
    dialog.querySelectorAll('.md-sg-scroll').forEach(function (caixa) {
      if (!visivel && caixa.offsetParent !== null) visivel = caixa;
    });
    nota.hidden = !visivel || visivel.scrollWidth <= visivel.clientWidth + 1;
  }

  function abrir(dialog) {
    sincronizar(dialog);
    aplicarUnidade(dialog);

    if (!dialog.dataset.mdSgPronto) {
      ligarIlustracao(dialog);
      dialog.dataset.mdSgPronto = '1';
    }

    // tocar no botao no meio da saida animada nao pode ser engolido: o ciclo de
    // fechamento em curso e cancelado e o painel volta pra posicao aberta
    cancelarSaida(dialog);

    // so guarda o overflow original quando o modal ainda esta fechado: abrir duas
    // vezes seguidas gravaria "hidden" como valor de origem e a pagina ficaria
    // travada pra sempre depois do fechamento
    if (!dialog.open) {
      dialog.dataset.mdSgOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    }

    if (!abrirComoModal(dialog)) {
      // nao subiu: devolve a rolagem em vez de deixar a loja presa
      destravarPagina(dialog);
      return;
    }
    // carimbo da abertura: o clique no fundo escuro so vale depois que o painel
    // terminou de subir (durante o deslize a caixa ainda esta deslocada, e um
    // segundo toque no mesmo botao cairia "fora" dela)
    dialog.dataset.mdSgAbertoEm = String(Date.now());
    vigiarTrava(dialog);

    // a nota de "arraste a tabela" so faz sentido quando ela realmente nao cabe.
    // Mede a tabela VISIVEL (a do celular e a do computador sao duas) e refaz a
    // conta no proximo quadro, quando o dialog ja esta na tela com as fontes.
    window.requestAnimationFrame(function () {
      ajustarNota(dialog);
      window.setTimeout(function () {
        ajustarNota(dialog);
      }, 250);
    });
  }

  /* ---------- saida animada no celular ----------
     Abrir e facil: o CSS anima sozinho com @starting-style. Fechar nao: o
     <dialog> sai da tela no mesmo instante em que close() e chamado, e a
     animacao nao chega a rodar. Por isso a classe md-sg-fechando desce o
     painel primeiro e o close() so acontece no fim da transicao. O timer e
     a rede de seguranca pra um transitionend que nao venha (aba em segundo
     plano, movimento reduzido ligado no meio do caminho). */
  var DURACAO_SAIDA = 280;
  var cicloDeSaida = 0;

  function ehCelular() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function movimentoReduzido() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Cancelar a saida e o que permite reabrir a tabela no meio do deslize: o
  // numero do ciclo muda, e o timer ou o transitionend que ainda estiverem a
  // caminho encerram sem fechar o modal recem-aberto.
  function cancelarSaida(dialog) {
    if (dialog.dataset.mdSgFechando !== '1') return;
    delete dialog.dataset.mdSgFechando;
    dialog.dataset.mdSgCiclo = '';
    dialog.classList.remove('md-sg-fechando');
  }

  function fechar(dialog) {
    var reserva = null;
    var meuCiclo = 0;

    var encerrar = function () {
      if (reserva) {
        window.clearTimeout(reserva);
        reserva = null;
      }
      // o ouvinte sai SEMPRE, inclusive quando quem encerra e o timer de reserva
      // (transicao cancelada por giro de tela, aba em segundo plano). Deixado
      // pendurado, ele fechava sozinho a abertura seguinte da tabela.
      dialog.removeEventListener('transitionend', aoTerminar);
      if (meuCiclo && dialog.dataset.mdSgCiclo !== String(meuCiclo)) return;
      dialog.classList.remove('md-sg-fechando');
      delete dialog.dataset.mdSgFechando;
      delete dialog.dataset.mdSgCiclo;
      pararVigia();
      destravarPagina(dialog);
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    function aoTerminar(evento) {
      if (evento.target !== dialog || evento.propertyName !== 'transform') return;
      encerrar();
    }

    // no computador a caixa e centralizada e some seca, como sempre foi
    if (!dialog.open || !ehCelular() || movimentoReduzido() || typeof dialog.close !== 'function') {
      encerrar();
      return;
    }

    if (dialog.dataset.mdSgFechando === '1') return;

    meuCiclo = ++cicloDeSaida;
    dialog.dataset.mdSgCiclo = String(meuCiclo);
    dialog.dataset.mdSgFechando = '1';
    dialog.classList.add('md-sg-fechando');

    reserva = window.setTimeout(encerrar, DURACAO_SAIDA + 80);
    dialog.addEventListener('transitionend', aoTerminar);
  }

  /* ---------- delegacao de eventos ---------- */
  document.addEventListener('click', function (evento) {
    var gatilho = evento.target.closest('[id^="open-size-chart-"], [data-md-sg-open]');
    if (gatilho) {
      var alvo = gatilho.hasAttribute('data-md-sg-open')
        ? porId(gatilho.getAttribute('data-md-sg-open'))
        : dialogDoGatilho(gatilho);
      if (alvo) {
        evento.preventDefault();
        abrir(alvo);
      }
      return;
    }

    var dialog = evento.target.closest('[data-md-sg]');
    if (!dialog) return;

    if (evento.target.closest('[data-md-sg-close]')) {
      evento.preventDefault();
      fechar(dialog);
      return;
    }

    // clique no fundo escuro: o <dialog> recebe o clique fora da caixa
    if (evento.target === dialog) {
      // enquanto o painel desce, o fechamento ja esta em curso
      if (dialog.dataset.mdSgFechando === '1') return;
      // duas esperas, porque sao dois problemas de escalas diferentes: o segundo
      // clique de um duplo clique chega em ~15ms e precisa ser engolido em
      // qualquer tela; ja os 320ms so fazem sentido no celular, onde o painel
      // leva 280ms subindo e qualquer toque ainda cai "fora" da caixa.
      var espera = ehCelular() && !movimentoReduzido() ? 320 : 60;
      if (Date.now() - Number(dialog.dataset.mdSgAbertoEm || 0) < espera) return;
      // o gesto inteiro precisa ter comecado no fundo: quem arrasta pra
      // selecionar uma medida e solta fora da caixa nao pode perder a tabela
      if (TEM_PONTEIRO && dialog.dataset.mdSgPressionouFundo !== '1') return;
      var caixa = dialog.getBoundingClientRect();
      var fora =
        evento.clientX < caixa.left ||
        evento.clientX > caixa.right ||
        evento.clientY < caixa.top ||
        evento.clientY > caixa.bottom;
      if (fora) fechar(dialog);
      return;
    }

    var botaoUnidade = evento.target.closest('[data-md-sg-unidade]');
    if (botaoUnidade) {
      evento.preventDefault();
      estadoUnidade = botaoUnidade.getAttribute('data-md-sg-unidade');
      guardarUnidade(estadoUnidade);
      aplicarUnidade(dialog);
      return;
    }

  });

  // Esc (e o gesto de voltar) fecha pelo caminho nativo, que pula a animacao:
  // barra o fechamento seco e refaz pelo nosso, pra sair deslizando igual
  document.addEventListener(
    'cancel',
    function (evento) {
      var dialog = evento.target;
      if (!dialog || !dialog.hasAttribute || !dialog.hasAttribute('data-md-sg')) return;
      if (dialog.dataset.mdSgFechando === '1' || !ehCelular() || movimentoReduzido()) return;
      evento.preventDefault();
      fechar(dialog);
    },
    true
  );

  // onde o gesto comecou: so fecha pelo fundo quem apertou NO fundo
  document.addEventListener(
    'pointerdown',
    function (evento) {
      var alvo = evento.target;
      if (!alvo || typeof alvo.closest !== 'function') return;
      var dialog = alvo.closest('[data-md-sg]');
      if (!dialog) return;
      if (alvo === dialog) dialog.dataset.mdSgPressionouFundo = '1';
      else delete dialog.dataset.mdSgPressionouFundo;
    },
    true
  );

  // Esc na captura da janela, antes de todo mundo: na loja viva o app de
  // consentimento de cookies chama preventDefault no keydown, e com isso o
  // evento 'cancel' do <dialog> NUNCA dispara - quem abria a tabela no
  // computador ficava preso nela, com a pagina travada, ate achar o X.
  window.addEventListener(
    'keydown',
    function (evento) {
      if (evento.key !== 'Escape' && evento.key !== 'Esc' && evento.keyCode !== 27) return;
      var dialog = document.querySelector('dialog[data-md-sg][open]');
      if (!dialog) return;
      evento.preventDefault();
      evento.stopPropagation();
      fechar(dialog);
    },
    true
  );

  // o dialog fechado pelo Esc nao passa pelo clique
  document.addEventListener(
    'close',
    function (evento) {
      var dialog = evento.target;
      if (dialog && dialog.hasAttribute && dialog.hasAttribute('data-md-sg')) {
        pararVigia();
        document.documentElement.style.overflow = dialog.dataset.mdSgOverflow || '';
      }
    },
    true
  );

  // Se o layout deixar de ser de celular (giro de tela) ou o cliente ligar
  // "reduzir movimento" no meio do gesto, a animacao de saida some do ar e o
  // painel voltaria a aparecer ate o timer vencer. Aqui o fechamento termina seco.
  (function () {
    if (typeof window.matchMedia !== 'function') return;
    var consultas = [window.matchMedia('(max-width: 749px)'), window.matchMedia('(prefers-reduced-motion: reduce)')];
    var aoMudar = function () {
      document.querySelectorAll('[data-md-sg]').forEach(function (dialog) {
        if (dialog.open) ajustarNota(dialog);
        if (dialog.dataset.mdSgFechando !== '1') return;
        cancelarSaida(dialog);
        fechar(dialog);
      });
    };
    consultas.forEach(function (consulta) {
      if (typeof consulta.addEventListener === 'function') consulta.addEventListener('change', aoMudar);
      else if (typeof consulta.addListener === 'function') consulta.addListener(aoMudar);
    });
  })();

  // troca de variante com a guia aberta: o destaque acompanha
  document.addEventListener('change', function (evento) {
    if (!evento.target.closest('variant-selects')) return;
    var atualizar = function () {
      document.querySelectorAll('[data-md-sg]').forEach(function (dialog) {
        if (dialog.open) sincronizar(dialog);
      });
    };
    atualizar();
    // o tema busca a section e reescreve o seletor de variantes depois do change:
    // sem esta segunda passada, "Sold out" continua apontando pro estoque antigo
    window.setTimeout(atualizar, 450);
  });
})();
